import { DataEntryDataType } from '../../../../api/pages-client/pages-client.type';

const DATA_ENTRY_DATA_TYPE_OPTIONS = [
  { value: DataEntryDataType.TEXT, label: 'Text' },
  { value: DataEntryDataType.FLOAT, label: 'Float' },
  { value: DataEntryDataType.INTEGER, label: 'Integer' },
  { value: DataEntryDataType.BOOLEAN, label: 'Boolean' },
  { value: DataEntryDataType.DATE, label: 'Date' },
  { value: DataEntryDataType.DATETIME, label: 'Datetime' },
];

export { DATA_ENTRY_DATA_TYPE_OPTIONS };
